import { render } from "./ButtonSecondary.vue?vue&type=template&id=7e8aa034&scoped=true&bindings={\"outline\":\"props\",\"lighterBorder\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"

import "./ButtonSecondary.vue?vue&type=style&index=0&id=7e8aa034&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e8aa034"

export default script